!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"object"==typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(l){var i=/\+/g;function m(e){return g.raw?e:encodeURIComponent(e)}function x(e,n){var o=g.raw?e:function(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(i," ")),g.json?JSON.parse(e):e}catch(e){}}(e);return l.isFunction(n)?n(o):o}var g=l.cookie=function(e,n,o){if(1<arguments.length&&!l.isFunction(n)){if("number"==typeof(o=l.extend({},g.defaults,o)).expires){var i=o.expires,r=o.expires=new Date;r.setMilliseconds(r.getMilliseconds()+864e5*i)}return document.cookie=[m(e),"=",function(e){return m(g.json?JSON.stringify(e):String(e))}(n),o.expires?"; expires="+o.expires.toUTCString():"",o.path?"; path="+o.path:"",o.domain?"; domain="+o.domain:"",o.secure?"; secure":""].join("")}for(var t,c=e?void 0:{},u=document.cookie?document.cookie.split("; "):[],s=0,a=u.length;s<a;s++){var d=u[s].split("="),f=(t=d.shift(),g.raw?t:decodeURIComponent(t)),p=d.join("=");if(e===f){c=x(p,n);break}e||void 0===(p=x(p))||(c[f]=p)}return c};g.defaults={},l.removeCookie=function(e,n){return l.cookie(e,"",l.extend({},n,{expires:-1})),!l.cookie(e)}});

Array.prototype.random = function () {
  return this[Math.floor((Math.random()*this.length))];
};

(function($){
    $(document).on('mouseleave', function(e) {
       var $leaving_modal = $('#myModal-leaving');

    if( e.clientY < 0 && $.cookie("leave-modal") !== 'hide') {

/* Disabled to stop bombing admin-ajax.php
            $.ajax({
                url: ajaxurl,
                type: "POST",
                dataType: 'json',
                data: {'action' : 'leaving_modal_load'},
                success: function (data) {
                    $leaving_modal.css({
                        'background-image' : 'url("'+ data.background +'")',
                        'background-position' : data.background_position
                    });
                    $leaving_modal.append('<img src="'+data.background+'" style="position: aboslute: width: 0; height: 0; visibility: hidden;" loading="lazy">');
                    $leaving_modal.find('.js-modal-content').html(data.text);
                    $leaving_modal.find('.js-form-holder').html(data.form);
                    html_element = document.querySelector('#myModal-leaving .wpcf7-form');
                    wpcf7.init(  html_element );
                    $leaving_modal.find('input[name="source"]').attr('value', data.source);
                    $leaving_modal.find('input[type="submit"]').attr('value', data.submit_button);
                    $leaving_modal.find('input[name="custom-page-slug"]').attr('value', $leaving_modal.data('page-slug'));
                },
                error : function (e) {
                    console.log(e);
                }
            });
*/          var $imageFeatures = $('#leavingModalfeatures');

            if ($imageFeatures.data('white_text') == '1') {
              $leaving_modal.addClass('white_text');  
            }

            $leaving_modal.css({
                        'background-image' : 'url("'+ $imageFeatures.attr('src') +'")',
                        'background-position' : $imageFeatures.data('background_position')
            });

//            var html_element = document.querySelector('#myModal-leaving .wpcf7-form');
//            wpcf7.init(  html_element );

            $leaving_modal.find('input[name="source"]').attr('value', $imageFeatures.data('source'));
            $leaving_modal.find('input[type="submit"]').attr('value', $imageFeatures.data('submit_button'));
            $leaving_modal.find('input[name="custom-page-slug"]').attr('value', $leaving_modal.data('page-slug'));

            var $modal_wrapper = $leaving_modal.parent('.fade_wrapper');
                
                $modal_wrapper.css({
                    'display' : 'block',
                    'visibility' : 'visible',
                    'opacity' : '1'
                });

                $leaving_modal.css({
                    'display' : 'inline-block',
                    'visibility' : 'visible',
                    'opacity' : '1'
                });

/* Disabled to stop bombing admin-ajax.php
                $.ajax({
                    url: ajaxurl,
                    type: "POST",
                    dataType: 'json',
                    data: {'action' : 'leaving_modal_statistics', 'source' : $modal.find('input[name="source"]').attr('value')},
                    success: function (data) {
                    },
                    error : function (e) {
                        console.log(e);
                    }
                });
*/

                $.cookie('leave-modal', 'hide', { path: '/' });

		}
	});

    $(document).on('click', '#myModal-leaving .close-reveal-modal', function(e) {
        e.preventDefault();
        var $modal = $(this).closest('.reveal-modal');
        var $modal_wrapper = $modal.parent('.fade_wrapper');

        $modal_wrapper.css({
            'display' : 'none',
            'visibility' : 'hidden',
            'opacity' : '0'
        });

        $modal.css({
            'display' : 'none',
            'visibility' : 'hidden',
            'opacity' : '0'
        });
    });

})(jQuery);
